import React from "react";
import { Link } from "react-router-dom";
import { formatPrice } from "../../../utilities";

const PurchaserCongrats = ({ influencer, video_title }) => (
  <div className="license-header">
    <i className="icon-congrats" />
    <h3>Thank you!</h3>
    <p>{`You now own the license for ${influencer.author_name}'s video, "${video_title}"`}</p>
  </div>
);

const InfluencerCongrats = ({ user, royalties }) => (
  <div className="license-purchased">
    <div className="license-header">
      <i className="icon-congrats" />
      <h3>Congrats!</h3>
      <p>
        {`${user.first_name} ${
          user.company_name && `from ${user.company_name} `
        }licensed your video`}
      </p>
    </div>
    <p>{`You will receive ${formatPrice(royalties)} in royalites.`}</p>
    <div className="important-header">
      <i className="icon-alert" />
      <h4>Important, please read</h4>
    </div>
    <span>
      Please make sure that your PayPal account email address for payment
      processing is entered on <Link to="/account/profile">your profile</Link>
      {" in order to receive your payment."}
    </span>
    <img src="assets/paypal-email-screenshot.png" />
  </div>
);

const LicenseAgreementPurchased = (props) =>
  props.isPurchaser ? (
    <PurchaserCongrats {...props} />
  ) : (
    <InfluencerCongrats {...props} />
  );

export default LicenseAgreementPurchased;
